import ABCyaLib from "@abcya/abcya_lib";
import Game from "./scenes/Game";
import Instructions from "./scenes/Instructions";
import Results from "./scenes/Results";
import Title from "./scenes/Title";

let bestScore = parseInt(ABCyaLib.Storage.getObject("feed_me_fractionsbestScore"));

export default {
    /**
     * Add your scene classes here. Simply put the scene class.
     * Ex: `scenes: [MyScene,MyOtherScene]`
     * @type {{KEY:string}[]}
     */
    scenes: [Title, Instructions, Game, Results],

    /**
     * Set the first scene that should be loaded here. Must match one of the scenes' key found in the scenes array.
     * It is recommended you put `MyScene.KEY` here instead of using a string.
     * @type {string}
     */
    startScene: Title.KEY,
    //startScene: Instructions.KEY,
    //startScene: Game.KEY,
    //startScene: Results.KEY,

    userData: {
        didWin: true,
        score: 0,
        // there was a bug in the game where it was setting the best time to 4, resulting in the best time always being 4
        // since it's impossible to have a best time of less than ~40 seconds, this additional check makes sure that the best time is set to 0
        bestScore: (!bestScore || bestScore < 5) ? 0 : bestScore
    }
}
